/* eslint-disable no-console */
import "./billing-info.scss"

import _get from "lodash/get"
import _map from "lodash/map"
import React, { useEffect, useState } from "react"
import {
  BillingInfoContainer,
  createFixedFloatNormalizer,
  currencyNormalizerCreator,
  OrderDetails,
  useCookieListener
} from "tf-checkout-react"

import { X_TF_ECOMMERCE } from "../../components/header"
import { deleteCookieByName, getCookieByName } from "../../utils/cookies"
import { defaultThemeSettings, setTfCheckoutReactConfigs } from "../../utils/tf-checkout-config"

// TEMP HIDE TICKET HOLDERS
const ticketHoldersFields = {
  id: 2,
  label: "Ticket Holders",
  fields: [
    {
      id: 1,
      groupClassname: "billing-info-container__twoFields",
      groupItems: [
        {
          className: "is-half",
          name: "holderFirstName",
          label: "First Name",
          type: "text",
          required: true,
          onValidate: () => {}
        },
        {
          className: "is-half",
          name: "holderLastName",
          label: "Last Name",
          type: "text",
          required: true,
          onValidate: () => {}
        }
      ]
    },
    {
      id: 2,
      groupClassname: "billing-info-container__twoFields",
      groupItems: [
        {
          className: "is-half",
          name: "holderEmail",
          label: "Email Address",
          type: "email",
          required: true,
          onValidate: () => {}
        },
        {
          className: "is-half",
          name: "holderPhone",
          label: "Phone",
          type: "phone",
          required: true,
          disableDropdown: false,
          onValidate: () => {}
        }
      ]
    }
  ]
}

const isWindowDefined = typeof window !== "undefined"

const paymentFields = [
  {
    label: "Event",
    id: "event_name",
    className: "field-underline"
  },
  {
    label: "Your Tickets",
    id: "ticketType",
    className: "field-underline"
  },
  {
    label: "Add-ons",
    id: "add_ons",
    className: "field-underline span-6 column"
  },
  {
    label: (
      <div>
        <span>Total</span>
      </div>
    ),
    id: "total",
    className: "",
    normalizer: (value, currency) =>
      currencyNormalizerCreator(createFixedFloatNormalizer(2)(parseFloat(value || 0)), currency)
  }
]

const tablePaymentFields = [
  {
    label: "Event",
    id: "event_name",
    className: "field-underline"
  },
  {
    label: "Your Reservation",
    id: "ticketType",
    className: "field-underline"
  },
  {
    label: "Add-ons",
    id: "add_ons",
    className: "field-underline span-6 column"
  },
  {
    label: (
      <div>
        <span>Total</span>
      </div>
    ),
    id: "total",
    className: "",
    normalizer: (value, currency) =>
      currencyNormalizerCreator(createFixedFloatNormalizer(2)(parseFloat(value || 0)), currency)
  },
  {
    label: (
      <div>
        <span>Pay Now</span>
      </div>
    ),
    id: "pay_now",
    className: "",
    normalizer: (value, currency) =>
      currencyNormalizerCreator(createFixedFloatNormalizer(2)(parseFloat(value || 0)), currency)
  },
  {
    label: (
      <div>
        <span>Pay on Check-in</span>
      </div>
    ),
    id: "debt",
    className: "",
    normalizer: (value, currency) =>
      currencyNormalizerCreator(createFixedFloatNormalizer(2)(parseFloat(value || 0)), currency)
  }
]

setTfCheckoutReactConfigs()

const billingInfoFields = [
    {
      id: 1,
      label: "Checkout",
      labelClassName: "main-header",
      fields: [
        {
          id: 2,
          groupClassname: "billing-info-container__twoFields",
          groupItems: [
            {
              className: "is-half",
              name: "firstName",
              label: "First Name",
              type: "text",
              required: true,
              onValidate: () => {}
            },
            {
              className: "is-half",
              name: "lastName",
              label: "Last Name",
              type: "text",
              required: true,
              onValidate: () => {}
            }
          ]
        },
        {
          id: 3,
          groupClassname: "billing-info-container__twoFields",
          groupItems: [
            {
              className: "is-half",
              name: "email",
              label: "Email",
              type: "email",
              required: true,
              onValidate: () => {}
            },
            {
              className: "is-half",
              name: "confirmEmail",
              label: "Confirm Email",
              type: "email",
              required: true,
              onValidate: () => {}
            }
          ]
        },
        {
          id: 1,
          groupClassname: "billing-info-container__singleField email-info-block-container",
          groupItems: [
            {
              className: "",
              name: "email-info",
              label: "",
              type: "",
              component: (
                <div className="email-info-block">
                  <b>IMPORTANT</b>
                  <span>
                    : Please double check that your email address is correct. It's where we send your confirmation!
                  </span>
                </div>
              )
            }
          ]
        },
        {
          id: 4,
          groupClassname: "billing-info-container__singleField choose-password-field-block",
          groupItems: [
            {
              className: "",
              name: "password-info",
              label: "",
              type: "",
              component: (
                <div className="email-info-block">
                  <span>Choose a password for your new</span>
                  <b> TFSports </b>
                  <span>account</span>
                </div>
              )
            }
          ]
        },
        {
          id: 5,
          groupClassname: "billing-info-container__twoFields password-field-block",
          groupItems: [
            {
              className: "is-half",
              name: "password",
              label: "Password",
              type: "password",
              required: true,
              onValidate: password => {
                if (password.length < 8) {
                  return "Password must contain at least 8 characters"
                }
                if (password.length > 32) {
                  return "Password must contain at most 32 characters"
                }
                if (!new RegExp("^(?=.*[@$!%*#?&])").test(password)) {
                  return "Password must contain at least one special character"
                }
                // if (!new RegExp("^(?=.*[A-Z])").test(password)) {
                //   return "Password must contain at least one uppercase character"
                // }
                // if (!new RegExp("\\d").test(password)) {
                //   return "Password must contain at least one number"
                // }
                return null
              }
            },
            {
              className: "is-half",
              name: "confirmPassword",
              label: "Confirm Password",
              type: "password",
              required: true,
              onValidate: confirmPassword => {
                if (confirmPassword.length < 8) {
                  return "Password must contain at least 8 characters"
                }
                if (confirmPassword.length > 32) {
                  return "Password must contain at most 32 characters"
                }
                if (!new RegExp("^(?=.*[@$!%*#?&])").test(confirmPassword)) {
                  return "Password must contain at least one special character"
                }
                // if (!new RegExp("^(?=.*[A-Z])").test(confirmPassword)) {
                //   return "Password must contain at least one uppercase character"
                // }
                // if (!new RegExp("\\d").test(confirmPassword)) {
                //   return "Password must contain at least one number"
                // }
                return null
              }
            }
          ]
        },
        {
          id: 6,
          groupClassname: "billing-info-container__singleField phone-field-block",
          groupItems: [
            {
              className: "",
              name: "phone",
              label: "Phone",
              type: "phone",
              required: true,
              disableDropdown: false,
              fill: true,
              onValidate: () => {}
            }
          ]
        },
        {
          id: 7,
          groupClassname: "billing-info-container__singleField",
          groupItems: [
            {
              className: "",
              name: "street_address",
              label: "Billing Street Address",
              type: "text",
              required: true,
              onValidate: () => {}
            }
          ]
        },
        {
          id: 8,
          groupClassname: "billing-info-container__singleField",
          groupItems: [
            {
              className: "country-field",
              name: "country",
              label: "Country",
              type: "select",
              required: true,
              onValidate: () => {}
            }
          ]
        },
        {
          id: 9,
          groupClassname: "billing-info-container__twoFields",
          groupItems: [
            {
              className: "is-half state-field",
              name: "state",
              label: "State/County",
              type: "select",
              required: true,
              onValidate: () => null
            },
            {
              className: "is-half",
              name: "city",
              label: "City/Suburb",
              type: "text",
              required: true,
              onValidate: city => {
                const regex = /^[\p{L}\s'.-]+$/u
                if (!regex.test(city)) {
                  return "City must contain only letters"
                }
                return null
              }
            }
          ]
        },
        {
          id: 19,
          groupClassname: "billing-info-container__singleField",
          groupItems: [
            {
              className: "",
              name: "zip",
              label: "Post Code/Zip",
              type: "text",
              required: true,
              onValidate: zip => {
                if (!new RegExp("^[0-9A-Za-z\- ]+$").test(zip)) {
                  return "Postal code must contain only numbers and letters"
                }
                return null
              }
            }
          ]
        },
        {
          id: 10,
          groupClassname: "billing-info-container__singleField",
          groupItems: [
            {
              className: "",
              name: "holderAge",
              label: "Date of Birth",
              type: "date",
              required: true,
              format: "MM/DD/YYYY",
              placeholder: "mm/dd/yyyy",
              onValidate: () => {}
            }
          ]
        },
        {
          id: 11,
          groupClassname: "billing-info-container__singleField",
          groupItems: [
            {
              className: "",
              name: "data_capture[wallet_address]",
              label: "Wallet address",
              type: "text",
              required: false,
              onValidate: () => {}
            }
          ]
        },
        {
          id: 13,
          groupClassname: "billing-info-container__singleField email-info-block-container",
          groupItems: [
            {
              className: "",
              name: "wallet-address-info",
              label: "",
              type: "",
              component: <div className="email-info-block">For promotional drops from participating sponsors.</div>
            }
          ]
        },
        {
          id: 14,
          groupClassname: "billing-info-container__singleField",
          groupItems: [
            {
              className: "",
              name: "data_capture[jobTitle]",
              label: "Job Title",
              type: "text",
              required: false,
              onValidate: () => {}
            }
          ]
        },
        {
          id: 15,
          groupClassname: "billing-info-container__singleField",
          groupItems: [
            {
              className: "",
              name: "data_capture[businessCategory]",
              label: "Business Category",
              type: "select",
              required: false,
              selectOptions: [
                {
                  value: "",
                  label: ""
                },
                {
                  value: "Boutique or Store",
                  label: "Boutique or Store"
                },
                {
                  value: "Business Coach",
                  label: "Business Coach"
                },
                {
                  value: "Business Development Manager",
                  label: "Business Development Manager"
                },
                {
                  value: "Clothing Brand",
                  label: "Clothing Brand"
                },
                {
                  value: "Colorist",
                  label: "Colorist"
                },
                {
                  value: "Cutter",
                  label: "Cutter"
                },
                {
                  value: "Designer",
                  label: "Designer"
                },
                {
                  value: "Digital Creator",
                  label: "Digital Creator"
                },
                {
                  value: "Fabric Mill",
                  label: "Fabric Mill"
                },
                {
                  value: "Faculty Member",
                  label: "Faculty Member"
                },
                {
                  value: "Fashion Education",
                  label: "Fashion Education"
                },
                {
                  value: "Fashion Show Production",
                  label: "Fashion Show Production"
                },
                {
                  value: "Fashion Week",
                  label: "Fashion Week"
                },
                {
                  value: "Garment Manufacturer",
                  label: "Garment Manufacturer"
                },
                {
                  value: "Jewelry Brand",
                  label: "Jewelry Brand"
                },
                {
                  value: "Merchandiser",
                  label: "Merchandiser"
                },
                {
                  value: "Model",
                  label: "Model"
                },
                {
                  value: "Pattern Maker",
                  label: "Pattern Maker"
                },
                {
                  value: "Photographer",
                  label: "Photographer"
                },
                {
                  value: "Product Development Manager",
                  label: "Product Development Manager"
                },
                {
                  value: "Production Manager",
                  label: "Production Manager"
                },
                {
                  value: "Professional Services",
                  label: "Professional Services"
                },
                {
                  value: "Retoucher",
                  label: "Retoucher"
                },
                {
                  value: "Sales Associate",
                  label: "Sales Associate"
                },
                {
                  value: "Seamstress",
                  label: "Seamstress"
                },
                {
                  value: "Student",
                  label: "Student"
                },
                {
                  value: "Stylists",
                  label: "Stylists"
                },
                {
                  value: "Trade Show",
                  label: "Trade Show"
                },
                {
                  value: "Trim Supplier",
                  label: "Trim Supplier"
                },
                {
                  value: "Yarn Mill",
                  label: "Yarn Mill"
                }
              ],
              onValidate: () => {}
            }
          ]
        },
        {
          id: 16,
          groupClassname: "billing-info-container__singleField",
          groupItems: [
            {
              className: "",
              name: "data_capture[company]",
              label: "Company",
              type: "text",
              required: false,
              onValidate: () => {}
            }
          ]
        },
        {
          id: 17,
          groupClassname: "billing-info-container__singleField email-info-block-container",
          groupItems: [
            {
              className: "",
              name: "instagram-info",
              label: "",
              type: "",
              component: <div className="email-info-block" />
            }
          ]
        },
        {
          id: 18,
          groupClassname: "billing-info-container__singleField",
          groupItems: [
            {
              className: "",
              name: "data_capture[instagram]",
              label: "Instagram",
              type: "text",
              required: false,
              onValidate: () => {}
            }
          ]
        },
        {
          id: 12,
          groupClassname: "billing-info-container__singleField billing-info-checkboxes-block",
          groupItems: [
            {
              className: "width-fc",
              name: "brand_opt_in",
              label: (
                <span className="checkbox-text">(optional) Keep me updated on TFSports events, news and more.</span>
              ),
              type: "checkbox"
            },
            {
              className: "width-fc privacy-policy-block",
              name: "ttf_opt_in",
              required: true,
              label: (
                <span className="checkbox-text">
                  I have read and agree to TFSports{" "}
                  <a href="https://d1au5iau2exwyo.cloudfront.net/Politica_Privacidade_Clientes_Versao_19_06_2023_0c0eb720a0.pdf" target="_blank" rel="noreferrer">
                    Privacy Policy.
                  </a>
                </span>
              ),
              type: "checkbox"
            }
          ]
        }
      ]
    }
]

const BillingPage = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(isWindowDefined ? !!getCookieByName(X_TF_ECOMMERCE) : false)
  const [orderData, setOrderData] = useState(null)
  const [hasTable, setHasTable] = useState(false)

  const onLoginSuccess = () => {
    setIsLoggedIn(true)
    if (typeof window !== "undefined") {
      const event = new window.CustomEvent("tf-login")
      window.document.dispatchEvent(event)
    }
  }

  useCookieListener(X_TF_ECOMMERCE, value => setIsLoggedIn(Boolean(value)))

  // Hide add-on custom fields when quantity is 0
  useEffect(() => {
    if (!isWindowDefined) return

    const hideCustomFieldsForEmptyAddons = () => {
      // Wait for the form to render
      setTimeout(() => {
        // Find all custom field containers that are children of add-on sections
        const customFieldContainers = document.querySelectorAll('.billing-info-container__customFields')

        customFieldContainers.forEach(container => {
          // Check if this custom field is within an add-on context
          // by looking for the parent add-on container
          const parentAddOn = container.closest('[class*="addon"], .MuiAccordion-root')

          if (parentAddOn) {
            // Try to find the quantity select for this add-on
            const quantitySelect = parentAddOn.querySelector('select[name^="addon"]')

            if (quantitySelect) {
              const quantity = parseInt(quantitySelect.value) || 0

              // Hide/show custom fields based on quantity
              if (quantity === 0) {
                container.style.display = 'none'
              } else {
                container.style.display = ''
              }

              // Add event listener to the select
              quantitySelect.addEventListener('change', () => {
                const newQuantity = parseInt(quantitySelect.value) || 0
                if (newQuantity === 0) {
                  container.style.display = 'none'
                } else {
                  container.style.display = ''
                }
              })
            }
          }
        })
      }, 1000)
    }

    hideCustomFieldsForEmptyAddons()

    // Re-run when checkout updates (add-ons change)
    const observer = new MutationObserver(() => {
      hideCustomFieldsForEmptyAddons()
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true
    })

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <div className="billing-info">
      <h1 className="billing-page-heading">Billing Information</h1>
      <BillingInfoContainer
        CustomLogin={null}
            brandOptIn={true}
            enableTimer={true}
            themeOptions={defaultThemeSettings}
            onCountdownFinish={() => {
              if (typeof window !== "undefined") {
                window.location.href = "/events"
              }
            }}
            onGetCartError={() => {
              if (typeof window !== "undefined") {
                window.location.href = "/events"
              }
            }}
            // logo={Logo}
            ticketHoldersFields={ticketHoldersFields}
            data={billingInfoFields}
            isLoggedIn={isLoggedIn}
            onLoginSuccess={onLoginSuccess}
            handleSubmit={async (values, formikHelpers, eventId, res, checkoutRes, paymentResponse) => {
              if (isWindowDefined) {
                const { hash, total } = _get(res, "data.attributes")
                const { order_hash, total: freeTotal } = _get(paymentResponse, "data.attributes.order_details", {
                  order_hash: null,
                  total: null
                })
                const needIdVerification = _get(paymentResponse, "data.attributes.needIdVerification") || false
                // The SDK only passes a paymentResponse once Stripe confirmed the payment and the
                // order success call returned 200. Its status isn't always "succeeded": the backend
                // reports "processed" when the webhook settled the order first (common on mobile),
                // or the raw intent status ("processing", "requires_capture"). Gating on "succeeded"
                // left paid buyers on the form with an active pay button.
                const paymentStatus = _get(paymentResponse, "data.attributes.status")
                const successfulPaidOrder =
                  !!paymentResponse && !["requires_payment_method", "canceled"].includes(paymentStatus)
                const successfulFreeOrder = Number(freeTotal) === 0 && order_hash === hash

                if (successfulPaidOrder || successfulFreeOrder || needIdVerification) {
                  try {
                    window.localStorage.setItem("checkoutData", JSON.stringify({ hash, total }))

                    if (needIdVerification) {
                      window.location.replace("/verification")
                    } else {
                      window.location.replace("/billing/checkout-complete")
                    }
                  } catch (error) {
                    console.error("Redirect error:", error)
                  }
                }
              }
            }}
            onRegisterError={e => {
              // Handle registration errors if needed
            }}
            initialValues={{
              firstName: "",
              lastName: "",
              email: "",
              confirmEmail: "",
              phone: "",
              street_address: "",
              city: "",
              state: "",
              zip: "",
              holderFirstName: "",
              holderLastName: "",
              holderAge: ""
            }}
            theme="light"
            buttonName="Submit Payment"
            freeOrderButtonName="Complete Registration"
            isCountryCodeEditable={false}
            skipCustomFields={false}
            onPendingVerification={() => {
              if (isWindowDefined) {
                window.location.replace(`/verification`)
              }
            }}
            onGetProfileDataError={error => {
              if (error.response.status === 401) {
                setIsLoggedIn(false)
                deleteCookieByName(X_TF_ECOMMERCE)
                if (isWindowDefined) {
                  window.localStorage.removeItem("user_data")
                }
              }
            }}
            includeAddons
            addonsProps={{
              samePage: true,
              descriptionTrigger: "always",
              useStepperQty: true,
            }}
            isSinglePageCheckout={true}
            onCheckoutUpdateSuccess={data => {
              if (data?.total === undefined || data?.total === null || !data.tickets_price_breakdown) {
                return
              }

              const expiresAt = data?.expires_at || 0
              const checkoutData = data
              let orderHasTable = false
              const ticketTypePrices = checkoutData.tickets_price_breakdown.map(ticketTypePrice => {
                orderHasTable = hasTable || !!ticketTypePrice.is_table
                return {
                  id: ticketTypePrice.ticket_type_id,
                  isTable: !!ticketTypePrice.is_table,
                  quantity: ticketTypePrice.quantity,
                  groupName: ticketTypePrice.group_name,
                  name: ticketTypePrice.ticket_type_name,
                  price: ticketTypePrice.price_per_ticket,
                  guestCount: ticketTypePrice.guest_count || 0,
                  cost:
                    ticketTypePrice.cost_per_ticket ??
                    ticketTypePrice.price_per_ticket - ticketTypePrice.fees_per_ticket
                }
              })
              setOrderData(current => ({
                ...current,
                event_name: checkoutData.event_name,
                ticketType: ticketTypePrices,
                quantity: checkoutData.tickets_price_breakdown[0].quantity,
                price: checkoutData.tickets_price_breakdown[0].price_per_ticket,
                total: checkoutData.total + (checkoutData.debt || 0),
                pay_now: checkoutData.total,
                debt: checkoutData.debt,
                currency: checkoutData.currency.currency,
                add_ons: _map(checkoutData.add_ons_price_breakdown, item => ({
                  id: item.id || "temp_id",
                  name: item.add_on_name,
                  groupName: item.group_name || "",
                  price: item.price_per_add_on,
                  cost: item.cost_per_add_on ?? item.price_per_add_on,
                  quantity: item.quantity
                })),
                expires_at: expiresAt
              }))
              setHasTable(orderHasTable)
            }}
            paymentProps={{
              paymentFields: hasTable ? tablePaymentFields : paymentFields
            }}
            paymentSectionAddon={
              !!orderData && <div className="payment-info-wrapper">
                <OrderDetails
                  orderData={orderData}
                  paymentFieldsData={hasTable ? tablePaymentFields : paymentFields}
                  customMobileText="Order Details"
                />
            </div>
            }
          />
        </div>
  )
}

export default BillingPage
